import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { BaseOption } from 'src/app/model/BaseOption';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { SessionService } from 'src/app/session-service.service';
import { BaseComponent } from '../BaseComponent';
import { ConfigSettingDto } from '../../model/business/ConfigSettingDto';

@Component({
  selector: 'app-toggle-input',
  templateUrl: 'toggle-input.html',
  styleUrls: ['toggle-input.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ToggleInputComponent extends BaseComponent implements OnInit {
  @Input()
  optionsList: BaseOption[];
  @Input()
  breaks = true;
  @Input()
  cofigBlock: boolean;
  @Input()
  backgroundTextColor: string;
  @Input()
  backgroundColor: string;
  @Input()
  formSubmitted: boolean;
  @Input()
  secondInsured: boolean;
  @Input()
  inputBorderColor: string;
  @Input()
  fontColor: string;
  @Input()
  fontSize: string;
  @Input()
  groupBy2InLine: boolean;
  @Input()
  freeText: string;
  @Input()
  inputColor: string;
  @Input()
  placeholderPrefix: string;
  @Input()
  disabled = false;

  @Input()
  additionalInfoInsurer: string;
  controlType = this.constructor.name;
  FontTypeEnum = FontTypeEnum;

  constructor(
    translateService: TranslateService,
    sessionService: SessionService,
    private componentCommunicationService: ComponentCommunicationService
  ) {
    super(translateService, sessionService);
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
    } catch (e) {
      console.error(
        `Failed initializing toggle-input with placeholder ${this.placeholder}`
      );
    }
  }

  openPopup(): void{
    this.componentCommunicationService.loadDialog(this.additionalInfoInsurer);
  }

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }
}
